import React from 'react';
import { Grid } from '@mui/material';
import { validateRule } from 'AurionCR/components/formV2';
import { useFormContext, Controller } from 'react-hook-form';
import { useSourceDoctors } from 'components/hooks';
import { useFieldProps, useFormDefaultValue } from 'hooks';
import { SelectPatients } from 'components/select-patients';
import { useTranslate } from 'hooks/use-translate';
import { AppInput } from 'components/app-input';
import { AppSelect } from 'components/app-select';
import { AppDatePicker } from 'components/app-date-picker';

interface Props {
  isLoading: boolean;
}

export const Form: React.FC<React.PropsWithChildren<Props>> = ({ isLoading }) => {
  const { t } = useTranslate();
  const {
    control,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const getFieldProps = useFieldProps({ errors, emptyHelperText: '', disabled: isLoading });

  const sourceDoctors = useSourceDoctors(true);
  useFormDefaultValue(sourceDoctors.data?.[0]?.id, {
    watch,
    setValue,
    name: 'userEmployeeProfileID',
  });

  return (
    <Grid container spacing={3}>
      <Grid
        size={{
          md: 6,
        }}
      >
        <Controller
          name={'entryDate'}
          control={control}
          rules={validateRule('required,dateLike')}
          render={({ field: renderProps }) => (
            <AppDatePicker {...getFieldProps(renderProps)} disabled={isLoading} />
          )}
        />
      </Grid>
      <Grid
        size={{
          md: 6,
        }}
      >
        <Controller
          name={'userEmployeeProfileID'}
          control={control}
          rules={validateRule('required')}
          render={({ field: renderProps }) => {
            return (
              <AppSelect
                {...getFieldProps(renderProps)}
                label={t('doctor')}
                loading={sourceDoctors.loading}
                options={sourceDoctors.data}
                disableClearable
              />
            );
          }}
        />
      </Grid>
      <Grid
        size={{
          md: 12,
        }}
      >
        <Controller
          name={'userPatientProfileID'}
          rules={validateRule('required')}
          control={control}
          render={({ field: renderProps }) => {
            return (
              <SelectPatients
                {...getFieldProps(renderProps)}
                label={t('patient')}
                disableClearable
              />
            );
          }}
        />
      </Grid>
      <Grid
        size={{
          md: 12,
        }}
      >
        <Controller
          name={'remarks'}
          control={control}
          defaultValue={t('prescription-validity')}
          render={({ field: renderProps }) => {
            return <AppInput {...getFieldProps(renderProps)} multiline minRows={3} />;
          }}
        />
      </Grid>
    </Grid>
  );
};
